import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { SentryAppErrorFallback } from './components/SentryAppErrorFallback.tsx';
import { initSentry, Sentry } from './lib/sentry.ts';
import './index.css';

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryAppErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
